import React from 'react';
import { InputBase, FormHelperText } from '@material-ui/core';
import { useField } from 'react-final-form-hooks';

export default function ({ form, prefixName, name, label, icon, margin = 'normal', children, hint, hidden, ...props }) {
  const prefixForm = prefixName ? `${prefixName}.` : '';
  const field = useField(`${prefixForm}${name}`, form);
  const zhHkField = useField(`${prefixForm}i18n.zh-hk.${name}`, form);
  const enField = useField(`${prefixForm}i18n.en.${name}`, form);
  const onChange = (e) => {
    field.input.onChange(e);
    enField.input.onChange(e);
  };
  if (hidden) {
    return null;
  }

  return (
    <>
      <div className="mt-3 mb-4">
        <div className="border border-grey-c" style={{ marginTop: '4px', marginBottom: '1px', borderRadius: 3 }}>
          <small className="position-absolute bg-white px-1" style={{ left: 10, top: '-10px' }}>
            {label}
          </small>
          <div className="flex-row">
            <div className="flex px-2 py-1 border-right border-grey-c">
              <small
                className="mr-2 position-absolute bg-white bottom right grey-b"
                style={{ right: 5, bottom: '-10px' }}
              >
                English
              </small>
              <InputBase {...field.input} value={field.input.value || ''} multiline rows="12" fullWidth onChange={onChange} />
            </div>
            <div className="flex px-2 py-1">
              <InputBase {...zhHkField.input} value={zhHkField.input.value || ''} multiline rows="12" fullWidth />
              <small
                className="mr-2 position-absolute bg-white bottom right grey-b"
                style={{ right: 5, bottom: '-10px' }}
              >
                Chinese
              </small>
            </div>
          </div>
        </div>
        {field.meta.touched && field.meta.error ? (
          <FormHelperText style={{ color: 'red' }}>{field.meta.error}</FormHelperText>
        ) : null}
        {zhHkField.meta.touched && zhHkField.meta.error ? (
          <FormHelperText style={{ color: 'red' }}>{zhHkField.meta.error}</FormHelperText>
        ) : null}
      </div>
    </>
  );
}
